import { cva, type VariantProps } from "class-variance-authority";
import { type HTMLAttributes } from "react";
import { cn } from "../../lib/cn";

const alertVariants = cva("ui-alert", {
  variants: {
    tone: {
      info: "ui-alert-info",
      success: "ui-alert-success",
      warning: "ui-alert-warning",
      danger: "ui-alert-danger"
    }
  },
  defaultVariants: {
    tone: "info"
  }
});

export interface AlertProps
  extends HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof alertVariants> {}

export function Alert({ "aria-atomic": ariaAtomic, "aria-live": ariaLive, className, role, tone, ...props }: AlertProps) {
  const resolvedRole = role ?? (tone === "danger" ? "alert" : tone === "success" ? "status" : undefined);
  const resolvedLive = ariaLive ?? (tone === "danger" ? "assertive" : tone === "success" ? "polite" : undefined);
  const resolvedAtomic = ariaAtomic ?? (resolvedRole ? true : undefined);

  return (
    <div
      className={cn(alertVariants({ tone }), className)}
      role={resolvedRole}
      aria-live={resolvedLive}
      aria-atomic={resolvedAtomic}
      {...props}
    />
  );
}
